import React from 'react';
import classnames from 'classnames';
import {
  string, node, arrayOf, shape, oneOfType
} from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

export const Images = ({
  images,
  separator,
  wrapperClasses,
  imageClasses,
  separatorClasses
}) => {

  const wrapperClassnames = classnames('sui-flex sui-items-stretch sui-justify-center', wrapperClasses);
  const imageClassnames = classnames('sui-flex sui-flex-col sui-gap-4 sui-items-center sui-justify-end', imageClasses);
  const separatorClassnames = classnames('sui-m-auto sui-pb-6', separatorClasses);

  return (
    <div className="sui-flex sui-justify-center">
      <div className={wrapperClassnames}>
        {images.map(({ url, subText, height, width }, index) => (
          <React.Fragment key={`image-wrapper - ${url}`}>
            <div className={imageClassnames}>
              <img
                key={`image - ${url}`}
                src={url}
                alt={`Image: ${subText}`}
                height={height}
                width={width}
              />
              {!!subText && (
                <div className="sui-text-nowrap">
                  <Typography
                    key={`${subText} - ${url}`}
                    variant="body-xs"
                    component="span"
                  >
                    {subText}
                  </Typography>
                </div>
              )}
            </div>
            {(!!separator && index < images.length - 1) && (
              <div className="sui-flex sui-items-center">
                <span className={separatorClassnames}>
                  {separator}
                </span>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

Images.propTypes = {
  images: arrayOf(shape({
    url: string.isRequired,
    subText: string,
    height: string,
    width: string
  })).isRequired,
  separator: oneOfType([string, node]),
  wrapperClasses: string,
  imageClasses: string,
  separatorClasses: string
};

Images.defaultProps = {
  separator: '',
  wrapperClasses: '',
  imageClasses: '',
  separatorClasses: ''
};
